var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"donut-chart"}},[_c('canvas',{ref:"donutChart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }